export const DEFAULT_PHONE_LABELS = ['mobile', 'work', 'house', 'other'];
